module.exports = TalendReactBootstrap;